import type React from 'react';
import { Controller, type Control } from 'react-hook-form';
import type { CartValues } from '@shared/types/cart';
import type { CDEKCity } from '@shared/types/delivery';
import { Blank, Loader } from 'library/components/common';
import { useDelivery } from '../../model';
import { CitySelect } from '../city-select';
import { DeliveryMap } from '../delivery-map';
import { Method } from '../method';
import { PointSelect } from '../point-select';
import * as st from './styles.module.scss';

interface Props {
  control: Control<CartValues, object>;
}

export const Delivery: React.FC<Props> = ({ control }) => {
  const delivery = useDelivery();

  return (
    <>
      <div className={st.address}>
        <Controller
          control={control}
          name="city"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CitySelect
              citySearch={delivery.city}
              onSearchChange={delivery.setCity}
              cities={delivery.cityList}
              onChange={onChange}
              selected={value}
              error={error}
              setCity={delivery.saveCity}
            />
          )}
          defaultValue={delivery.selectedCity}
        />

        {delivery.selectedCity && delivery.pickupPoints.length > 0 && <Method />}

        {delivery.pickupPoints.length > 0 && (
          <>
            <Controller
              control={control}
              name="pickup_point"
              render={({ field: { onChange, value }, fieldState: { error } }) => (
                <PointSelect
                  points={delivery.pickupPoints}
                  selected={value}
                  onChange={onChange}
                  error={error}
                  savePoint={delivery.savePoint}
                />
              )}
              defaultValue={delivery.selectedPoint}
            />
            <div className={st.deliveryNotice}>
              <span className={st.mark}>*</span>Доставка не входит в стоимость товара и оплачивается
              при получении
            </div>
          </>
        )}
      </div>

      <div className={st.map}>
        {delivery.cityLoading === 'loading' && <Loader text="Загрузка городов" />}
        {delivery.cityLoading !== 'loading' && delivery.pointsLoading === 'loading' && (
          <Loader text="Загрузка точек выдачи" />
        )}
        {delivery.cityLoading === 'loaded' &&
          delivery.pointsLoading === 'loaded' &&
          delivery.pickupPoints?.length === 0 && (
            <Blank text="В выбранном городе нет пунктов выдачи CDEK. Выберите другой город, в котором есть доставка CDEK" />
          )}
        {delivery.pointsLoading === 'loaded' &&
          delivery.pickupPoints?.length > 0 &&
          delivery.selectedCity && (
            <Controller
              control={control}
              name="pickup_point"
              render={({ field: { onChange, value }, fieldState: { error } }) => (
                <DeliveryMap
                  points={delivery.pickupPoints}
                  city={delivery.selectedCity ?? ({} as CDEKCity)}
                  value={value}
                  onChange={onChange}
                  savePoint={delivery.savePoint}
                />
              )}
              defaultValue={delivery.selectedPoint}
            />
          )}
      </div>
    </>
  );
};
